import { render, staticRenderFns } from "./AsMainDayFinishSubList.vue?vue&type=template&id=10732f58"
import script from "./AsMainDayFinishSubList.vue?vue&type=script&lang=js"
export * from "./AsMainDayFinishSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports